import { portfolioProject } from "./portfolio";
import { porscheInformatikProject } from "./porsche-informatik";
import { panoramaBogensportProject } from "./panorama-bogensport";
import { Project } from "./types";
import { falkenholzProject } from "./falkenholz";

export const projects: Project[] = [
  falkenholzProject,
  portfolioProject,
  porscheInformatikProject,
  panoramaBogensportProject,
];

export type { Project };
